import { useMonitorShipSelections } from '@ais-ui/api';
import { useAISMapContext } from './AISMapContext';
import { useEffect, useMemo, useState } from 'react';
import { AutoCompleteShipInfo } from '@ais-ui/websockets';
import { ToString } from '@formatjs/ecma402-abstract';
import { useSettings } from '../Settings/SettingsProvider';
import { useToast } from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';

export const useZoomToExternalShip = () => {
  const { settings } = useSettings();
  const { messages } = useLocalization();

  const isRemoteControlEnabled = useMemo(() => {
    return settings['ribbonPlugin.settings']?.remotecontrol_enabled ?? false;
  }, [settings]);

  const { toast } = useToast();

  const { data, isError } = useMonitorShipSelections(isRemoteControlEnabled);

  const { setZoomToShip } = useAISMapContext();

  useEffect(() => {
    if (!data) {
      return;
    }

    if (isError) {
      toast({
        title: messages.genericToastTitleError,
        description: 'Error fetching selected ship data',
        variant: 'destructive',
      });
      return;
    }

    if (!data?.records) {
      return;
    }

    if (data.records.length === 0) {
      return;
    }

    if (!data.records[0].ship) {
      return;
    }

    if (data.records[0].ship.length === 0) {
      toast({
        title: messages.genericToastTitleError,
        description: "Couldn't find ship requested from remote access",
        variant: 'destructive',
      });
      return;
    }

    const ship = data.records[0].ship[0];
    const mmsiName = ship?.name !== ship?.mmsi ? ship.name : '';
    const autoCompleteShip = {
      name: mmsiName ? mmsiName : '',
      mmsi: ship.mmsi ? ToString(ship.mmsi) : null,
      imo: ship.imo ? ToString(ship.imo) : null,
      callSign: ship.callsign ? ship.callsign : null,
      type: 'TT_SHIP',
    };

    setZoomToShip(autoCompleteShip);
  }, [data, isError, messages.genericToastTitleError, setZoomToShip, toast]);
};
